//lib
import { useFormikContext } from "formik";
import {
  MDBDropdown,
  MDBDropdownItem,
  MDBDropdownMenu,
  MDBDropdownToggle,
} from "mdb-react-ui-kit";

//component
import Row from "./row";
import Col from "./col";

export default function Dropdown({
  label,
  // name,
  options,
  placeholder,
  className,
  onClick,
  field,
  form,
}) {
  const { name, value } = field;
  const { setFieldValue, errors, touched } = form;

  // const formik = useFormikContext();

  return (
    <>
      <Col className={`element _dropdown ${className ? className : ""}`}>
        {label && (
          <Row>
            <label>{label}</label>
          </Row>
        )}
        <Row>
          <MDBDropdown className={value ? "active" : ""}>
            <MDBDropdownToggle type="button">
              {name && value
                ? value
                : placeholder
                ? placeholder
                : "Select Options"}
            </MDBDropdownToggle>
            <MDBDropdownMenu>
              {options &&
                options.map((option, index) => (
                  <MDBDropdownItem
                    key={index}
                    onClick={() => {
                      if (onClick) {
                        onClick(option.value);
                      }

                      setFieldValue(name, option.value);
                    }}
                  >
                    {option.label}
                  </MDBDropdownItem>
                ))}
            </MDBDropdownMenu>
          </MDBDropdown>
        </Row>
      </Col>
      {errors && errors[name] ? (
        <Row className="element _errors">{errors[name]}</Row>
      ) : null}
    </>
  );
}
